import {HttpClient} from '../core/request'
import { parse } from 'querystring'
import { availableParams } from '../core/helper';
// ------------------------------------
// Constants
import 'url-search-params-polyfill';

// ------------------------------------
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME';

// ------------------------------------
// Actions
// ------------------------------------
export function setCategories(categories, cid = -1) {
    categories = setActiveCategory(categories, cid);
    return {
        type: SET_CATEGORIES,
        payload: categories
    }
}

export function createSearchParams(paramName, params = []) {
    let url = new URLSearchParams(window.location.search);
    let cities = (params.length > 0) ? params : url.getAll(paramName + '[]');
    let urlString = false;
    if (cities.length > 0) {
        urlString = paramName+'[]=' + cities.join('&'+paramName+'[]=');
    }

    const keys = Object.keys(parse(url.toString()));

  keys.map(el => {
    if (!availableParams.includes(el.replace(/[\W]+/g, ""))) {
      url.delete(el);
    }
  });

    return urlString;
}

export const loadCategories = (cities = [], regions = []) => {
    return (dispatch, getState) => {
        let state = getState();
        let url = 'prepaid_deals/categories';
        let cityParams = createSearchParams('cities', cities);
        let urlForCategory = false;
        if (cityParams) {
            url += '?' + cityParams;
            urlForCategory = cityParams;
        } else {
            let regionParams = createSearchParams('regions', regions);
            if (regionParams) {
                url += '?' + regionParams;
                urlForCategory = regionParams;
            }
        }

        return HttpClient().get(url).then(resp => {
            let cid = -1,
                items = resp.data,
                count = 0;
            // items.map(item => {
            //     count += parseInt(item.count);
            // });
            items = setCategoriesUrl(items, urlForCategory);
            // items.push({
            //     id: 0,
            //     count: count,
            //     items: [],
            //     name: 'All deals',
            //     parent_id: null,
            //     url: urlForCategory ? urlForCategory : ''
            // });
            if (state.location.query && state.location.query.category_id > 0) {
                cid = parseInt(state.location.query.category_id);
            }
            dispatch(setCategories(items, cid));
            dispatch(setCategoryName(items, cid))
        }).catch(error => {
            console.log('Error', error)
        })
    }
};

const setCategoriesUrl = (items, params) => {
    let newItems = [];
    let url = '&' + params;
    if (params === false) {
        url = '';
    }

    items.map(item => {
        if (item.id) {
            item.url = 'category_id=' + item.id + url;
        } else {
            item.url = url;
        }
        if (item.items) {
            let sub = [];
            item.items.map(i => {
                i.url = 'category_id=' + i.id + url;
                sub.push(i);
            });
            item.items = sub;
        }
        newItems.push(item);
    });

    return newItems;
};

const setActiveCategory = (categories, cid) => {
    cid = parseInt(cid);
    if (cid === -1) {
        return categories;
    }
    let items = [];
    categories.map((i) => {
        let item = i;
        if (item.id === cid) {
            if (item.opened) {
                item.active = false;
                item.opened = false;
            } else {
                item.active = true;
                item.opened = true;
            }
        } else {
            item.active = false;
            item.opened = false;
        }
        if (item.items) {
            let sub = [];
            item.items.map((k) => {
                let j = k;
                if (j.id === cid) {
                    j.active = true;
                    item.opened = true;
                } else {
                    j.active = false;
                }
                sub.push(j);
            });
            item.items = sub;
        }
        items.push(item);
    });
    return items;
};


export const setCategoryName = (categories, cid) => {
  for (let category of categories) {
    if (category.id == cid) {
      return  {
        type: SET_CATEGORY_NAME,
        payload: category.name
      }
    }
    if (category.items.length) {
      for (let subCategory of category.items) {
        if (subCategory.id == cid) {
          return  {
            type: SET_CATEGORY_NAME,
            payload: subCategory.name
          }
        }
      }
    }
  }

  return  {
    type: SET_CATEGORY_NAME,
    payload: ''
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
export function categoryReducer(state = [], action) {
    return action.type === SET_CATEGORIES
        ? action.payload
        : state
}

export function categoryNameReducer(state = '', action) {
    return action.type === SET_CATEGORY_NAME
        ? action.payload
        : state
}



// WEBPACK FOOTER //
// ./src/store/category.js